import { Trans } from 'react-i18next';

import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';
import { StrongText } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';

import { InvoiceItemsTableBean } from './InvoiceItemsTable.types';
import { useUnitsPriceSum } from './TotalGrossPrice.hooks';
import { StyledTotalGrossPrice } from './TotalGrossPrice.styled';

type TotalGrossPriceProps = {
   readonly invoiceItems: InvoiceItemsTableBean[] | undefined;
};

export const TotalGrossPrice = (props: TotalGrossPriceProps): JSX.Element => {
   const sumPrice = useUnitsPriceSum(props.invoiceItems);

   return (
      <StyledTotalGrossPrice
         type={'h2'}
         testId={'totalGrossPrice'}
         margin={'0px'}
         content={
            <Trans
               i18nKey={
                  sumPrice
                     ? invoiceCreateModalTranslationKeys.unitPriceSum
                     : invoiceCreateModalTranslationKeys.unitPriceSumPlaceholder
               }
               components={{
                  bold: <StrongText testId={'unitsPriceSum'} />,
               }}
               values={{
                  grossPrice: priceFormatter(
                     sumPrice,
                     getCustomFormattingContext({
                        options: {
                           currency: 'PLN',
                        },
                     })
                  ),
               }}
            />
         }
      />
   );
};
